var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            width: "900px",
            title: "选择供应商",
            "before-close": _vm.handleClose,
            visible: _vm.Open,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.Open = $event
            },
          },
        },
        [
          _c("BaseTable", {
            ref: "baseTable",
            attrs: { "fn-init": _vm.Fninit, table: _vm.table },
            on: { handleSupplier: _vm.handleSupplier },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }